import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import GuideDownload from "@/pages/GuideDownload";
import PackageConfirmation from "@/pages/PackageConfirmation";
import Questionnaire from "@/pages/Questionnaire";
import Assessment from "@/pages/Assessment";
import AssessmentConfirmation from "@/pages/AssessmentConfirmation";
import Members from "@/pages/Members";
import Portal from "@/pages/Portal";
import Legal from "@/pages/Legal";
import PetResume from "@/pages/PetResume";
import ResumeReviewIntake from "@/pages/ResumeReviewIntake";
import ResumeReviewStart from "@/pages/ResumeReviewStart";
import EmploymentCoaching from "@/pages/EmploymentCoaching";
import EmploymentCoachingConfirmation from "@/pages/EmploymentCoachingConfirmation";
import AuthChoose from "@/pages/AuthChoose";
import RelocatorIntake from "@/pages/RelocatorIntake";
import RoleSearchIntake from "@/pages/RoleSearchIntake";
import Jobs from "@/pages/Jobs";
import BlogPost, { BlogIndex } from "@/pages/Blog";
import NewsletterPopup from "@/components/NewsletterPopup";
import CandidateBoard from "@/pages/CandidateBoard";
import "@/App.css";

// Auto-detect brand from hostname so the popup styling matches the domain.
// theditchcareers.com.au (and any preview URL with "careers") → careers brand.
// Everything else defaults to the Collective brand.
function _detectBrand() {
  if (typeof window === "undefined") return "collective";
  const host = window.location.hostname.toLowerCase();
  if (host.includes("theditchcareers") || host.includes("careers.")) return "careers";
  return "collective";
}
const BRAND = _detectBrand();

function App() {
  const privateEmployerBoard = typeof window !== "undefined" && window.location.pathname.startsWith("/candidate-board");
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      {!privateEmployerBoard && <NewsletterPopup brand={BRAND} source="site" />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/guides/download" element={<GuideDownload />} />
        <Route path="/packages/confirmation" element={<PackageConfirmation />} />
        <Route path="/questionnaire" element={<Questionnaire />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/assessment/confirmation" element={<AssessmentConfirmation />} />
        <Route path="/members" element={<Members />} />
        <Route path="/members/pet-resume" element={<PetResume />} />
        <Route path="/pet-resume" element={<PetResume mode="free" />} />
        <Route path="/resume-review/start" element={<ResumeReviewStart />} />
        <Route path="/employment-coaching" element={<EmploymentCoaching />} />
        <Route path="/employment-coaching/confirmation" element={<EmploymentCoachingConfirmation />} />
        <Route path="/resume-review/intake" element={<ResumeReviewIntake />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/candidate-board" element={<CandidateBoard />} />
        <Route path="/auth/choose" element={<AuthChoose />} />
        <Route path="/move" element={<RelocatorIntake />} />
        <Route path="/roles" element={<RoleSearchIntake />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/privacy" element={<Legal kind="privacy" />} />
        <Route path="/refund" element={<Legal kind="refund" />} />
        <Route path="/disclaimer" element={<Legal kind="disclaimer" />} />
        <Route path="/affiliate" element={<Legal kind="affiliate" />} />
        <Route path="/third-party" element={<Legal kind="third-party" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
